import EditOutlined from '@ant-design/icons/EditOutlined';
import DeleteOutlined from '@ant-design/icons/lib/icons/DeleteOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import Button from 'antd/lib/button';
import Card from 'antd/lib/card/Card';
import Divider from 'antd/lib/divider';
import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import React from 'react';
import { WARNING_COLOR } from '../../../theme';
import { ISavedFilter } from './interface';

const BACKGROUND_COLOR = '#f5f5f5';
const OUTDATED_FILTER_COLOR = '#fff2f0'; // Color for outdated filters
const BORDER_COLOR = '#d9d9d9';

interface ISavedFilterCardProps {
    filter: ISavedFilter;
    appliedSavedFilterId: number | null;

    onFilterApply: (filter: ISavedFilter) => void;
    onFilterEdit: (filter: ISavedFilter) => void;
    onFilterDelete: (filter: ISavedFilter) => void;
}

export const SavedFilterCard: React.FC<ISavedFilterCardProps> = ({ filter, appliedSavedFilterId, onFilterApply, onFilterDelete, onFilterEdit }) => {
    const isFilterSelected = appliedSavedFilterId === filter.id;

    const handleEdit = (filter: ISavedFilter, e: React.SyntheticEvent) => {
        e.stopPropagation();

        onFilterEdit(filter);
    };

    const handleDelete = (filter: ISavedFilter, e: React.SyntheticEvent) => {
        e.stopPropagation();

        onFilterDelete(filter);
    };

    const handleApply = (filter: ISavedFilter, e: React.SyntheticEvent) => {
        e.stopPropagation();

        onFilterApply(filter);
    };

    return (
        <Card
            size="small"
            style={{
                cursor: filter.isOutdated ? 'not-allowed' : 'pointer',
                borderRadius: 0,

                border: `1px solid ${isFilterSelected ? 'var(--ant-color-primary)' : 'transparent'}`,
                borderBottom: `1px solid ${isFilterSelected ? 'var(--ant-color-primary)' : BORDER_COLOR}`,
                borderLeft: `6px solid ${isFilterSelected ? 'var(--ant-color-primary)' : 'transparent'}`,
                backgroundColor: filter.isOutdated ? OUTDATED_FILTER_COLOR : BACKGROUND_COLOR,
            }}
            styles={{
                body: {
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    padding: 0,
                },
            }}
            onClick={e => !filter.isOutdated && handleApply(filter, e)}
        >
            <div style={{ padding: 12, paddingRight: 8 }}>
                <Typography.Paragraph strong ellipsis={{ rows: 2 }} style={{ marginBottom: 8 }}>
                    {filter.isOutdated && (
                        <Tooltip title="This filter contains values that are currently unavailable." placement="right">
                            <WarningOutlined style={{ fontSize: 16, color: WARNING_COLOR, marginRight: 8 }} />
                        </Tooltip>
                    )}

                    {filter.filter_name}
                </Typography.Paragraph>

                <Typography.Paragraph ellipsis={{ rows: 2 }} type="secondary" style={{ marginBottom: 8 }}>
                    {filter.description}
                </Typography.Paragraph>
            </div>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: 8,
                    padding: 8,
                    marginLeft: 'auto',
                }}
            >
                <Button icon={<DeleteOutlined style={{ fontSize: 16 }} />} type="text" danger onClick={e => handleDelete(filter, e)} />

                <Divider style={{ margin: 0, backgroundColor: BORDER_COLOR }} />

                <Button icon={<EditOutlined style={{ fontSize: 16 }} />} type="text" onClick={e => handleEdit(filter, e)} />
            </div>
        </Card>
    );
};
